import React from 'react'
import Bread_1 from '../../../assets/images/home_page_4/breadcrumb/05.png'
import Bread_2 from '../../../assets/images/home_page_4/breadcrumb/04.png'

const BreadCrumbimage2 = () => {
    return (
        <>
            <section className="breadcrumb-image-two-main-block">
                <div className="container">
                    <div className="breadcrumb-image-two-block">
                        <div className="row">
                            <div className="col-xl-6 col-lg-6">
                                <div className="breadcrumb-image-two-dtl-block">
                                    <div className="breadcrumb-image-two-dtl">
                                        <img
                                            src={Bread_1}
                                            className="img-fluid"
                                            alt=""
                                        />
                                        <p>
                                            We have prepared special discounts for you on electronic
                                            products. Don't miss these opportunities...
                                        </p>
                                    </div>
                                    <div className="breadcrumb-image-two-contact-dtl">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <h3 className="text-white">Address</h3>
                                                <p>
                                                    Dhaka 102, 8000 sent behaibior utl 1216, road 45 house of
                                                    street
                                                </p>
                                            </div>
                                            <div className="col-lg-6">
                                                <h3 className="text-white">Lets Talk us</h3>
                                                <ul>
                                                    <li>Phone number: +32566 - 800 - 890</li>
                                                    <li>Fax: 1234 -58963 - 007 </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6">
                                <div className="discount-two-img">
                                    <img
                                        src={Bread_2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="breadcrumb-image-two-bg" />
                    </div>
                </div>
            </section>


        </>
    )
}

export default BreadCrumbimage2
